import { Typography } from "@packages/ds";
import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const Message = styled.p`
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 15px;
  margin: 0 0 8px;
  line-height: 24px;
  &:nth-child(2) {
    margin-bottom: 16px;
  }
`;

export const Note = styled.p`
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 13px;
  margin: 0px;
  ${semiBoldAlias()};
`;

export const Strong = styled.strong`
  ${semiBoldAlias()};
`;

export const BodyText = styled(Typography.BodyText)`
  margin-top: 16px;
`;
